<template>
  <fts-dropdown-select ref="dropdown" class="text-variation-dropdown" content-class="text-variation-dropdown-menu"
    :offset="[0, 6]" @show="openDropdown" @hide="confirmSelection">
    <template #toggle>
      <slot name="toggle" />
    </template>

    <template #menu>
      <div class="font-control">
        <div class="font-weights">
          <div class="weight light" :class="{ selected: style === 'l' }" @click="toggleStyle('l')">Light</div>
          <div class="weight normal" :class="{ selected: !style }" @click="toggleStyle(null)">Normal</div>
          <div class="weight bold" :class="{ selected: style === 'b' }" @click="toggleStyle('b')">Bold</div>
        </div>
        <div class="divider"></div>
        <div class="font-sizes">
          <div class="size small" :class="{ selected: size === 'S' }" @click="toggleSize('S')">S</div>
          <div class="size medium" :class="{ selected: !size }" @click="toggleSize(null)">M</div>
          <div class="size large" :class="{ selected: size === 'L' }" @click="toggleSize('L')">L</div>
        </div>
      </div>
    </template>
  </fts-dropdown-select>
</template>


<script>

import FTSToggleSwitch from '../elements/FTSToggleSwitch';
import FTSDropdownSelect from "../elements/FTSDropdownSelect";
import FTSLabelGroup from '../elements/FTSLabelGroup';
import FTSCheckbox from '../elements/FTSCheckbox';
import commons from '../commons/commons';

export default {
  name: 'TextVariationDropdown',
  components: {
    'fts-toggle-switch': FTSToggleSwitch,
    "fts-dropdown-select": FTSDropdownSelect,
    'fts-label-group': FTSLabelGroup,
    "fts-checkbox": FTSCheckbox,
  },
  emits: ['select'],
  props: {
    initialVariation: Object,
  },
  data() {
    return {
      style: null, // l, null, b
      size: null, // S, null, L
    }
  },
  methods: {
    openDropdown() {
      this.style = this.initialVariation.style;
      this.size = this.initialVariation.size;
    },
    toggleSize(v) {
      this.size = v;
    },
    toggleStyle(v) {
      this.style = v;
    },
    confirmSelection() {
      this.$emit('select', {
        ...(this.size != null && { size: this.size }),
        ...(this.style != null && { style: this.style })
      });
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.font-control {
  width: 200px;
  display: flex;
  flex-direction: column;
  color: var(--fts-text);

  .font-weights,
  .font-sizes {
    display: flex;
    justify-content: space-between;
    text-align: center;

    >div {
      flex: 1;
      padding: 4px 8px;
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        background-color: #f0f0f0;
      }

      &.selected {
        color: var(--fts-primary);
      }
    }
  }

  .divider {
    height: 1px;
    background-color: var(--fts-border);
    margin: 4px;
  }

  .font-weights {
    .light {
      font-weight: 300;
    }

    .normal {
      font-weight: 500;
    }

    .bold {
      font-weight: 900;
    }
  }

  .font-sizes {
    .small {
      font-size: 0.8rem; // ~12px
    }

    .medium {
      font-size: 1rem; // ~16px
    }

    .large {
      font-size: 1.2rem; // ~20px
    }
  }
}
</style>
